export const BooleanValue = {
  True: 'true',
  False: 'false',
};

/** Label for active sale / PT listing count (grid, advanced filter, basic-search toggle). */
export const ACTIVE_SALE_LISTINGS_TOGGLE_LABEL = 'Active Sale Listings';

export const FieldOption = {
  animalId: { key: 'animalId', label: 'Animal Id', value: 'ANIMAL_ID' },
  animalIdent: {
    key: 'animalIdent',
    label: 'Animal Ident',
    value: 'ANIMAL_IDENT',
  },
  animalName: { key: 'animalName', label: 'Animal Name', value: 'ANIMAL_NAME' },
  animalStatus: {
    key: 'animalStatus',
    label: 'Animal Status',
    value: 'ANIMAL_STATUS',
  },
  breeder: { key: 'breeder', label: 'Breeder', value: 'BREEDER' },
  calvingYear: {
    key: 'calvingYear',
    label: 'Calving Year',
    value: 'CALVING_YEAR',
  },
  saleCount: {
    key: 'saleCount',
    label: ACTIVE_SALE_LISTINGS_TOGGLE_LABEL,
    value: 'SALE_COUNT',
  },
  colour: { key: 'colour', label: 'Colour', value: 'COLOUR' },
  dam: { key: 'dam', label: 'Dam', value: 'DAM' },
  dateOfBirth: {
    key: 'dateOfBirth',
    label: 'Date of Birth',
    value: 'DATE_OF_BIRTH',
  },
  isCompleted: { label: '', value: 'IS_COMPLETED' },
  lotCount: { label: 'Lots', value: 'LOT_COUNT' },
  lotNo: { key: 'lotNo', label: 'Lot', value: 'LOT_NO' },
  member: { key: 'member', label: 'Member', value: 'MEMBER' },
  memberName: { key: 'memberName', label: 'Name', value: 'MEMB_NAME' },
  memberId: { key: 'memberId', label: 'Member Id', value: 'MEMBER_ID' },
  memberIdent: {
    key: 'memberIdent',
    label: 'Member Ident',
    value: 'MEMBER_IDENT',
  },
  membershipType: {
    key: 'membershipType',
    label: 'Membership Type',
    value: 'MEMBER_TYPE',
  },
  currentOwner: { key: 'currentOwner', label: 'Owner', value: 'CURRENT_OWNER' },
  herdPrefix: { key: 'herd', label: 'Herd Prefix', value: 'PREFIX' },
  images: { key: 'images', label: 'Images', value: 'IMAGES' },
  registrationStatus: {
    key: 'registrationStatus',
    label: 'Registration Status',
    value: 'REGISTRATION_STATUS',
  },
  saleDate: { label: 'Sale Date', value: 'SALE_DATE' },
  saleId: { label: 'Sale Id', value: 'SALE_ID' },
  saleName: { label: 'Sale Description', value: 'SALE_NAME' },
  saleType: { label: 'Sale Type', value: 'SALE_TYPE' },
  sex: { key: 'sex', label: 'Sex', value: 'SEX' },
  sire: { key: 'sire', label: 'Sire', value: 'SIRE' },
  societyCode: { label: 'Society Code', value: 'SOCIETY_CODE' },
  societyId: { label: 'Society Id', value: 'SOCIETY_ID' },
  tattoo: { key: 'tattoo', label: 'Tattoo', value: 'TATTOO' },
  searchTerm: { key: 'searchTerm', label: 'Animal', value: 'ANIMAL' },
};

export type FilterInput = {
  field: string;
  operator: string;
  value: string;
};

export type FilterGroup = {
  filters: FilterInput[];
  logicalOperator: LogicalOperator;
};

export enum LogicalOperator {
  and = 'AND',
  or = 'OR',
}

export const OperatorOption = {
  contains: { label: 'Contains', value: 'CONTAINS' },
  between: { label: 'Between', value: 'BETWEEN' },
  endsWith: { label: 'Ends With', value: 'ENDS_WITH' },
  equals: { label: 'Equals', value: 'EQUALS' },
  greaterThan: { label: 'Greater Than', value: 'GREATER_THAN' },
  greaterThanOrEqual: {
    label: 'Greater Than or Equal',
    value: 'GREATER_THAN_OR_EQUAL_TO',
  },
  isNotEmpty: { label: 'Is Not Empty', value: 'NOT_NULL' },
  lessThan: { label: 'Less Than', value: 'LESS_THAN' },
  lessThanOrEqual: {
    label: 'Less Than or Equal',
    value: 'LESS_THAN_OR_EQUAL_TO',
  },
  notEquals: { label: 'Not Equals', value: 'NOT_EQUALS' },
  startsWith: { label: 'Starts With', value: 'STARTS_WITH' },
};

export const SortDirection = {
  asc: 'ASCENDING',
  desc: 'DESCENDING',
};

export const AnimalDefaultFieldOrder = [
  FieldOption.animalName,
  FieldOption.saleCount,
  FieldOption.animalStatus,
  FieldOption.animalIdent,
  FieldOption.dateOfBirth,
  FieldOption.sex,
  FieldOption.breeder,
  FieldOption.sire,
  FieldOption.dam,
  FieldOption.tattoo,
];

export const AnimalFields = [
  ...AnimalDefaultFieldOrder,
  FieldOption.calvingYear,
  FieldOption.colour,
  FieldOption.currentOwner,
  FieldOption.registrationStatus,
];

export const MemberDefaultFieldOrder = [
  FieldOption.memberIdent,
  FieldOption.memberName,
  FieldOption.herdPrefix,
];

export const MembersFields = [...MemberDefaultFieldOrder];

export const SaleDefaultFieldOrder = [
  FieldOption.saleDate,

  FieldOption.saleType,
  FieldOption.saleName,
  FieldOption.lotCount,
];

export const SemenDefaultFieldOrder = [
  FieldOption.saleName,
  FieldOption.saleType,
  FieldOption.lotCount,
];

export const SaleLotsDefaultFieldOrder = [
  FieldOption.lotNo,
  FieldOption.images,
  FieldOption.animalName,
  FieldOption.sex,
  FieldOption.animalIdent,
  FieldOption.dateOfBirth,
  FieldOption.registrationStatus,
];

export const FieldsWithLink = [
  FieldOption.animalName.value,
  FieldOption.animalIdent.value,
  FieldOption.breeder.value,
  FieldOption.currentOwner.value,
  FieldOption.dam.value,
  FieldOption.sire.value,
];

export type AnimalDocument = {
  url?: string | null;
  isPrimary?: boolean;
  isDeleted?: boolean;
  fileName?: string | null;
  documentId?: string | null;
};

export type GetAnimalsRow = {
  ANIMAL_IDENT: string;
  ANIMAL_NAME: string;
  ANIMAL_STATUS: string;
  BREEDER: LinkCell;
  COLOUR: string;
  CURRENT_OWNER: LinkCell;
  DAM: LinkCell;
  DAM_IDENT?: string;
  DATE_OF_BIRTH: string;
  ID: number;
  IMAGE: string;
  REGISTRATION_STATUS: string;
  SEX: string;
  SIRE: LinkCell;
  SIRE_IDENT?: string;
  TATTOO: string;
  TRAIT_LEADER?: string;
  /** Active sale / private-treaty listing count from `AnimalEbvDto.saleCount`. */
  SALE_COUNT?: number;
  /** Injected by `buildAnimalEbvRows` when the animal has associated documents. */
  documents?: AnimalDocument[] | null;
};

export type GetMembersRow = {
  ID?: number;
  MEMBER?: string;
  MEMB_NAME: string;
  MEMBER_ID: number;
  MEMBER_IDENT: string;
  PREFIX: string;
  memberId?: number;
  [key: string]: unknown;
};

export type GetSalesRow = {
  ID: number;
  LOT_COUNT: number;
  SALE_DATE: string;
  SALE_NAME: string;
  SALE_TYPE: string;
};

export type GetSaleLotsRow = {
  ANIMAL_IDENT: string;
  ANIMAL_NAME: string;
  ANIMAL_STATUS: string;
  DATE_OF_BIRTH: string;
  ID: number;
  IMAGE?: string;
  LOT_NO: string;
  REGISTRATION_STATUS: string;
  SEX: string;
  TRAIT_LEADER?: string;
  [key: string]: unknown;
};

export enum SaleType {
  BullListing = 'BL',
  CompletedPrivateTreatySaleListing = 'PR',
  CompletedSaleListing = 'SR',
  CompletedSemenListing = 'XR',
  CompletedEmbryoListing = 'MR',
  CurrentPrivateTreatySaleListing = 'PL',
  CurrentSaleListing = 'SL',
  EmbryoListing = 'ML',
  EventListing = 'EL',
  RecordsDirectory = 'RD',
  ReferenceSires = 'RS',
  ResultsReproductionData = 'RD',
  SemenListing = 'XL',
}

export type Row = {
  ID: number;
  [key: string]: LinkCell | string | number;
};

export type LinkCell = {
  id: number;
  value: string;
  detailsAvailFlag?: string | null;
};

export enum MemberFilterField {
  MEMBER_ID = 'MEMBER_ID',
  SOCIETY_ID = 'SOCIETY_ID',
  SOCIETY_CODE = 'SOCIETY_CODE',
  MEMBER_IDENT = 'MEMBER_IDENT',
  PREFIX = 'PREFIX',
  MEMB_NAME = 'MEMB_NAME',
  ADDRESS1 = 'ADDRESS1',
  ADDRESS2 = 'ADDRESS2',
  ADDRESS3 = 'ADDRESS3',
  POSTCODE = 'POSTCODE',
  SORTNAME = 'SORTNAME',
  PHONE_DETAILS = 'PHONE_DETAILS',
  EMAIL = 'EMAIL',
  HOMEPAGE = 'HOMEPAGE',
  DETAILS_AVAIL_FLAG = 'DETAILS_AVAIL_FLAG',
  BREEDPLAN_FLAG = 'BREEDPLAN_FLAG',
  MEMBER_TYPE = 'MEMBER_TYPE',
  MEMBER_NOTES = 'MEMBER_NOTES',
  HERD_SIZE = 'HERD_SIZE',
  HERD_SIZE_DESC = 'HERD_SIZE_DESC',
  SOC_ME_FIELD1 = 'SOC_ME_FIELD1',
  SOC_ME_FIELD2 = 'SOC_ME_FIELD2',
  SOC_ME_FIELD3 = 'SOC_ME_FIELD3',
  SOC_ME_FIELD4 = 'SOC_ME_FIELD4',
  SOC_ME_FIELD5 = 'SOC_ME_FIELD5',
  SOC_ME_FIELD6 = 'SOC_ME_FIELD6',
  SOC_ME_FIELD7 = 'SOC_ME_FIELD7',
  SOC_ME_FIELD8 = 'SOC_ME_FIELD8',
  SOC_ME_FIELD9 = 'SOC_ME_FIELD9',
  SOC_ME_FIELD10 = 'SOC_ME_FIELD10',
  MEMB_STATUS = 'MEMB_STATUS',
  MEMB_AUTH = 'MEMB_AUTH',
  ITEM_KEY = 'ITEM_KEY',
  RENEWAL_DATE = 'RENEWAL_DATE',
  RENEWAL_FEE = 'RENEWAL_FEE',
  SOC_ME_FIELD11 = 'SOC_ME_FIELD11',
  SOC_ME_FIELD12 = 'SOC_ME_FIELD12',
  SOC_ME_FIELD13 = 'SOC_ME_FIELD13',
  SOC_ME_FIELD14 = 'SOC_ME_FIELD14',
  SOC_ME_FIELD15 = 'SOC_ME_FIELD15',
  MAP_DETAILS = 'MAP_DETAILS',
}

export const PAGE_SIZE_OPTIONS = [10, 25, 50];
